export {
  tagsApi,
  useGetAllTagsQuery,
  useGetClientTagsQuery,
  useGetListTagsQuery,
  useGetTagByIdQuery,
  useGetTagsQuery,
  useLazyGetAllTagsQuery,
  useLazyGetClientTagsQuery,
  useLazyGetListTagsQuery,
  useLazyGetTagByIdQuery,
  useLazyGetTagsQuery,
  useRemoveClientsTagsMutation,
  useSetClientsTagsBySearchIdMutation,
  useSetClientsTagsMutation,
  useUpdateClientTagsMutation,
  useUpdateTagMutation,
} from './api';
export {
  TagsEndpoints,
  type GetAllTagsRequest,
  type GetAllTagsResponse,
  type GetClientTagsRequest,
  type GetClientTagsResponse,
  type GetListTagsRequest,
  type GetListTagsResponse,
  type GetTagByIdRequest,
  type GetTagByIdResponse,
  type GetTagsRequest,
  type GetTagsResponse,
  type ModelClientsTags,
  type ModelClientsTagsBySearchId,
  type ModelTag,
  type RemoveClientsTagsRequest,
  type RemoveClientsTagsResponse,
  type SetClientsTagsBySearchIdRequest,
  type SetClientsTagsBySearchIdResponse,
  type SetClientsTagsRequest,
  type SetClientsTagsResponse,
  type UpdateClientTagsRequest,
  type UpdateClientTagsResponse,
  type UpdateTagRequest,
  type UpdateTagResponse,
} from './types';
